export const PENDING_VRA_NOTE_MAX_LENGTH = 2000;

export const PENDING_VRA_NOTES_ACTION = 'notes';
export const PENDING_VRA_NOTES_ACTION_LABEL = 'Notes';

export const PENDING_VRA_NOTES_HEADER = 'Pending VRA Notes';
export const PENDING_VRA_NOTES_SORT_LABEL = 'newest first';
export const PENDING_VRA_NOTES_EMPTY_MESSAGE = 'No notes have been logged for this record.';
export const PENDING_VRA_NOTES_LOADING_MESSAGE = 'Loading notes...';
export const PENDING_VRA_NOTES_LOAD_ERROR = 'Could not load the notes for this VRA. Please try again.';
export const PENDING_VRA_NOTE_FIELD_LABEL = 'Add a note';
export const PENDING_VRA_NOTE_CONFIRM_LABEL = 'Add Note';
export const PENDING_VRA_NOTE_CANCEL_LABEL = 'Cancel';
export const PENDING_VRA_NOTE_REQUIRED_MESSAGE = 'A note is required.';
export const PENDING_VRA_NOTE_SAVE_ERROR = 'Failed to add the note. Please try again.';

export const PENDING_VRA_NOTE_DATE_PARSE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const PENDING_VRA_NOTE_DATE_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm';
